import type { ReactNode } from 'react';

/** Shared shell for every panel on the welcome screen, so the grid reads as one composition. */
export function SectionCard({
  title, subtitle, action, children, className = '', bodyClassName = '',
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <section className={`bg-white rounded-xl border border-stone-200/80 shadow-card overflow-hidden flex flex-col ${className}`}>
      <div className="px-5 py-4 flex items-center justify-between gap-3 border-b border-stone-100 shrink-0">
        <div className="min-w-0">
          <h2 className="text-[11px] font-semibold uppercase tracking-wider text-stone-600">{title}</h2>
          {subtitle && <p className="mt-0.5 text-[11px] text-stone-400 font-normal truncate">{subtitle}</p>}
        </div>
        {action}
      </div>
      <div className={`flex-1 ${bodyClassName}`}>{children}</div>
    </section>
  );
}
